<template>
  <div>
    <v-col>
      <Stepper2 />
    </v-col>
    <v-row>
      <div class="title">
        <InfoViaje
          textTitulo="Selecciona tus asientos"
          subTitulo4=""
          subTitulo5=""
        />    
      </div>
      <div class="back">
        <router-link to="/paso1">
          <button>
            <Back />
          </button>
        </router-link>
      </div>
    </v-row>
    <div class="componente">
      <div v-if="venta != null && venta.estructura[1].length != 0">
        <div class="toogle">
          <Toggle
            :ancho="true"
            buton1="Planta Alta"
            buton2="Planta Baja"
            @eventToogle="updatePlanta"
          />
        </div>
      </div>
      <div v-else>
        <div style="margin-top: -115px !important"></div>
      </div>
      <div v-if="venta != null" class="servicios">
          <Servicios :venta="venta" />
      </div>

      <br />
      <div class="box">
        <Asientos
          :posicion="posicion"
          @eventVenta="getVenta"
          :data="venta"
          @eventAsiento="getAsientos"
          :asientos="boleto_details"
          @eventBoletos="getBoletosIda"
        />
      </div>
    </div> 
    <!--
    <v-row>
      <ConfirmarAsiento />
    </v-row>
    <div class="aceptar">
      <button @click="validar();">
        <App-button buttonText="Aceptar"/>
      </button>
    </div>-->
  </div>
</template>

<style scoped lang="less">
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");
@media screen and (max-width: 480px) {
  .title {
    margin-top: 10%;
    text-align: left;
    margin-left: 6%;
  }

  .aceptar {
    margin-top: 30px !important;
  }
  .back {
    margin-left: 78%;
    margin-top: -33%;
  }

  .toogle{
    padding-left: 20px;
  }
  // fondo de los asientos
  .box {
    margin-right: 5%;
    margin-left: 5%;
    height: auto;
    width: 410px;
    margin-bottom: 10px;
    margin-top: 0px;
  }
  .componente {
    margin-top: -20%;
  }
  .servicios{
    margin-top: 5%;
    padding-left: 10px;
  }

}
@media screen and (min-width: 481px) and (max-width: 800px) {
  .title {
    margin-top: 10%;

    text-align: left;
    margin-left: 6%;
  }

  .aceptar {
    margin-top: 30px;
    margin-left: -12%;
  }
  .back {
    margin-left: 78px;
    margin-top: 80px;
  }
  // fonodo de los asientos
  .box {
    margin-right: -5%;
    margin-left: 15%;
    height: 80px;
    width: 500px;
  }
  .toogle {
    margin-left: 17%;
    
  }
  .servicios{
    margin-top: 120px;
  }
  .componente {
    margin-top: -28%;
  }
}
@media screen and (min-width: 802px) and (max-width: 870px) {
  .title {
    margin-top: -2%;

    text-align: left;
    margin-left: 6%;
  }

  .aceptar {
    margin-top: 30px;
    margin-left: -12%;
  }
  .back {
    margin-left: 78px;
    margin-top: 80px;
  }
  // fonodo de los asientos
  .box {
    margin-right: 5%;
    margin-left: 15%;
    height: 880px;
    width: 500px;
  }
  .toogle {
     margin-left: 17%;
  }
  .servicios{
    margin-top: 190px;
  }
  .componente {
    margin-top: -28%;
  }
}

@media screen and (min-width: 871px) and (max-width: 1200px) {
  .title {
    margin-top: -2%;

    text-align: left;
    margin-left: 6%;
  }

  .aceptar {
    margin-top: 30px;
  }
  .back {
    margin-left: 78px;
    margin-top: 60px;
  }
  // fonodo de los asientos
  .box {
    margin-right: 5%;
    margin-left: 22%;
    height: 880px;
    width: 500px;
  }
  .toogle {
    margin-left: 22%;
  }
  .servicios{
    margin-top: 190px;
  }
  .componente {
    margin-top: -20%;
  }
}
@media screen and (min-width: 1201px)  {
  .title {
    margin-top: -2%;
    text-align: left;
    margin-left: 6%;
  }

  .aceptar {
    margin-top: 30px;
  }
  .back {
    margin-left: 78px;
    margin-top: -30px;
  }
  // fondo de los asientos
  .box {
    margin-top: -25px !important;
    margin-right: 5%;
    margin-left: 29%;
    height: 880px;
    width: 500px;
  }
  .toogle {
    margin-left: 30%;
  }
  .servicios{
    margin-top: 190px;
    margin-left: 130px;
  }
  .componente {
    margin-top: -18%;
  }
}
@media screen and (min-width: 1366px)  {
  .title {
    margin-top: -2%;
    text-align: left;
    margin-left: 6%;
  }

  .aceptar {
    margin-top: 30px;
  }
  .back {
    margin-left: 78px;
    margin-top: -30px;
  }
  // fondo de los asientos
  .box {
    margin-top: -25px !important;
    margin-right: 5%;
    margin-left: 30%;
    height: 880px;
    width: 500px;
  }
  .toogle {
    margin-left: 30%;
  }
  .servicios{
    margin-top: 190px;
    margin-left: 0px;
  }
  .componente {
    margin-top: -18%;
  }
}
@media screen and (min-width: 1920px)  {
  .title {
    margin-top: -2%;
    text-align: left;
    margin-left: 6%;
  }

  .aceptar {
    margin-top: 30px;
  }
  .back {
    margin-left: 78px;
    margin-top: -40px;
  }
  // fondo de los asientos
  .box {
    margin-top: -25px !important;
    margin-right: 5%;
    margin-left: 35%;
    height: 880px;
    width: 500px;
  }
  .toogle {
    margin-left: 32%;
  }
  .servicios{
    margin-top: 190px;
  }
  .componente {
    margin-top: -13%;
  }
}
</style>

<script>
import axios from "axios";
import InfoViaje from "@/components/InfoViaje.vue";
import Back from "@/components/Back.vue";
import Seleccionado from "@/components/ButtonPrimary.vue";
import Stepper2 from "@/components/Stepper/Stepper2.vue";
import AppButton from "@/components/ButtonPrimary.vue";
import Toggle from "@/components/Toogle2.vue";
import Titulo from "@/components/title.vue";
import Cancel from "@/components/ButtonCancel.vue";
import Asientos from "@/components/Asientos.vue";
import Amenidades from "@/components/Amenidades.vue";
import Servicios from "@/components/Servicios.vue";
import ConfirmarAsiento from "@/components/ConfirmarAsientos.vue";

export default {
  name: "HomeView",
  props:{
    boletos_ida: { required: false },
    boletos_vuelta: { required: false }
  },
  data() {
    return {
      posicion: "alta",
      venta: null,
      boleto_details: null,
      asientos_ida: [],
      dirty_form: true,
      boletos: null,
      boletos_v: null
    };
  },
  components: {
    AppButton,
    InfoViaje,
    Back,
    Seleccionado,
    Stepper2,
    Toggle,
    Titulo,
    Cancel,
    Asientos,
    Amenidades,
    Servicios,
    ConfirmarAsiento,
  },
  created(){
    //this.boletos = JSON.parse(this.boletos_ida);
    //this.boletos_v = JSON.parse(this.boletos_vuelta);
    /*
    if(this.boletos){
      this.desbloquearAsientos(this.boletos)
    }else{
      this.boletos = null;
    }
    
    if(this.boletos_v){
      this.desbloquearAsientos(this.boletos_v)
    }else{
      this.boletos_v = null;
    }
      */
  },
  mounted(){
    //
  },

  methods: {
    iniciar() {},
    //guarda posicion de toogle
    updatePlanta() {
      this.posicion = localStorage.getItem("posicion");
    },
    //guarda datos de venta subcorrida obtenida
    getVenta(data) {
      this.venta = data;
    },
    getBoletosIda(data){
      this.$emit("eventBoletosIda", data)
    },
    //guarda asientos de ida seleccionados
    getAsientos(asientos) {
      this.asientos_ida = asientos;
    },

    async desbloquearAsientos(boletos){
      if(boletos != null && boletos.length > 0){
        for(let i=0; i < boletos.length; i++){
          
          let data = {
            data: {
              token_id: localStorage.getItem("token_id"),
              corrida_id: boletos[i].corrida_id,
              subcorrida_id: boletos[i].subcorrida_id,
              numero_asiento: boletos[i].numero,
              tipo: 'deseleccion',
              canal: 2
            },
          };
          try {
          const options = {
            headers: {
              Accept: "application/vnd.api+json",
              "Content-Type": "application/vnd.api+json"
            }
          };
          axios
            .post("/seleccionarAsiento", data, options).then((response) => {
              })
          }catch (error) {
            console.log(error);
          }
        }
        //localStorage.setItem('boleto', null);
      }
    },
  },
};
</script>